export default __webpack_public_path__ + "static/media/Ies_MesasCruzadas_Naomi_eACCESO_eng.e0ca2d79.jpg";